import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function cssBaseline(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root, #__next': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
        // SweetAlert2
        '.swal2-container': {
          zIndex: theme.zIndex.modal + 1100,
          '& .swal2-title': {
            fontSize: theme.typography.h6.fontSize,
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.text.primary,
          },
          '& .swal2-html-container': {
            fontSize: theme.typography.body2.fontSize,
            color: theme.palette.text.secondary,
          },
          '& .swal2-popup': {
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius * 2,
            padding: theme.spacing(3),
            boxShadow: theme.customShadows.z24,
          },
          '& .swal2-icon': {
            position: 'relative',
            boxSizing: 'content-box !important',
            justifyContent: 'center',
            width: '5em',
            height: '5em',
            margin: '1.25em auto 1.875em',
            border: '0.25em solid transparent',
            borderRadius: '50%',
            lineHeight: '5em',
            cursor: 'default',
            userSelect: 'none',
            '&.swal2-success': {
              borderColor: theme.palette.success.main,
              '& [class^=swal2-success-circular-line]': {
                position: 'absolute',
                width: '3.75em',
                height: '7.5em',
                transform: 'rotate(-45deg)',
                borderRadius: '50%',
                '&[class$=left]': {
                  top: '-0.4375em',
                  left: '-2.0635em',
                  transform: 'rotate(-45deg)',
                  transformOrigin: '3.75em 3.75em',
                  borderRadius: '7.5em 0 0 7.5em',
                },
                '&[class$=right]': {
                  top: '-0.6875em',
                  left: '1.875em',
                  transform: 'rotate(-45deg)',
                  transformOrigin: '0 3.75em',
                  borderRadius: '0 7.5em 7.5em 0',
                },
                backgroundColor: theme.palette.background.paper,
              },
              '& .swal2-success-ring': {
                position: 'absolute',
                zIndex: 2,
                top: '-0.25em',
                left: '-0.25em',
                boxSizing: 'content-box',
                width: '100%',
                height: '100%',
                border: `0.25em solid ${alpha(theme.palette.success.main, 0.3)}`,
                borderRadius: '50%',
              },
              '& .swal2-success-fix': {
                position: 'absolute',
                zIndex: 1,
                top: '0.5em',
                left: '1.625em',
                width: '0.4375em',
                height: '5.625em',
                transform: 'rotate(-45deg)',
                backgroundColor: theme.palette.background.paper,
              },
              '& [class^=swal2-success-line]': {
                display: 'block',
                position: 'absolute',
                zIndex: 2,
                height: '0.3125em',
                borderRadius: '0.125em',
                backgroundColor: theme.palette.success.main,
                '&[class$=tip]': {
                  top: '2.875em',
                  left: '0.875em',
                  width: '1.5625em',
                  transform: 'rotate(45deg)',
                },
                '&[class$=long]': {
                  top: '2.375em',
                  right: '0.5em',
                  width: '2.9375em',
                  transform: 'rotate(-45deg)',
                },
              },
            },
            '&.swal2-error [class^=swal2-x-mark-line]': {
              backgroundColor: theme.palette.error.main,
            },
            '&.swal2-warning, &.swal2-error, &.swal2-info, &.swal2-question': {
              borderColor: theme.palette.grey[500],
              '&.swal2-warning': { borderColor: theme.palette.warning.main },
              '&.swal2-error': { borderColor: theme.palette.error.main },
              '&.swal2-info': { borderColor: theme.palette.info.main },
            },
          },
          '& .swal2-actions': {
            gap: theme.spacing(1.5),
            '& button': {
              margin: '0 !important',
              fontSize: theme.typography.subtitle2.fontSize,
              fontWeight: theme.typography.fontWeightBold,
              borderRadius: theme.shape.borderRadius,
              padding: theme.spacing(1, 2.5),
              boxShadow: 'none !important',
            },
          },
          '& .swal2-confirm': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          '& .swal2-cancel': {
            backgroundColor: theme.palette.grey[500],
            color: theme.palette.common.white,
          },
        },
      },
    },
  };
}
